var parent = require('../../stable/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/symbol/iterator.js
// module id = 427
// module chunks = 0 1